import Pusher from "pusher-js";

export const pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY!, {
  cluster: process.env.VUE_APP_PUSHER_CLUSTER!,
  forceTLS: process.env.VUE_APP_PUSHER_SCHEME === "https",
});

export default pusher;
